import { useEffect, useState } from "react"
import type { AdTagGroup } from "@services/engagements/commands/cmdGetEngagementAdTags"
import { AdTagChips } from "src/modules/engagement/components/adTags/AdTagChips"
import { CreateServiceV3 } from "../../createV3/CreateService"
import Loader from "../../../components/common/loader/loader"

const createService = new CreateServiceV3()

/*
    An ad's Content Catalog tags, display only (MPN-1506).

    Shown when an ad is opened from an engagement's ad group page, where AdTagsPanel would
    be wrong twice over: the ticket is explicit that tags are managed in the Content Catalog
    and not edited from here, and the editable panel loads every tag in every group to fill
    its pickers. This needs one request — the tags actually on the ad.
*/
export default function AdTagsReadOnly({ adId }: { adId: number }) {
  const [groups, setGroups] = useState<AdTagGroup[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)

    createService
      .getTagsLinkedToTemplate(adId)
      .then((linked) => {
        if (!cancelled) setGroups((linked ?? []) as AdTagGroup[])
      })
      .catch(() => {
        // Tags are context, not the reason the ad was opened. A failure here shows the
        // empty state rather than taking down the editor.
        if (!cancelled) setGroups([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [adId])

  return (
    <div className="adtags-panel">
      <div className="adtags-panel__title">Tags</div>
      {loading ? (
        <div className="adtags-panel__loading">
          <Loader />
        </div>
      ) : groups.length === 0 ? (
        <div className="adtags-panel__empty">No tags on this ad</div>
      ) : (
        groups.map((group) => (
          <div key={group.id} className="adtags-panel__group">
            <span className="adtags-panel__group-name">{group.name}</span>
            <AdTagChips groups={[group]} all />
          </div>
        ))
      )}
    </div>
  )
}
